module.exports = __webpack_public_path__ + "media/packs/images/flags/VE-aee5be84e1565f999d7051adc9317f23.png";